<div class="d-flex">
  @for (t of tabs; track t) {
    <div class="tab-item" [ngClass]="{ 'tab-item__active': t === selectedTab }" (click)="selectTab(t)">{{ 'label.' + t | translate }}</div>
  }
</div>
<ng-content></ng-content>
